import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    questionId: Number,
    submitUrl: String
  }

  connect() {
    this.submitted = false
  }

  async submit() {
    if (this.submitted) return
    const text = this.inputTarget.value.trim()
    if (text === "") return
    this.submitted = true

    try {
      const response = await fetch(this.submitUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          question_id: this.questionIdValue,
          payload: { text: text }
        })
      })
      if (!response.ok) throw new Error(`Submit failed: ${response.status}`)
      this.element.classList.add("opacity-50", "pointer-events-none")
    } catch (error) {
      console.error("Short answer submit failed:", error)
      this.submitted = false
    }
  }
}
